import script from "./CombinationPosition.vue?vue&type=script&setup=true&lang=js"
export * from "./CombinationPosition.vue?vue&type=script&setup=true&lang=js"

import "./CombinationPosition.vue?vue&type=style&index=0&id=6ffaba08&lang=scss"

const __exports__ = script;

export default __exports__